"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.constructJobCorrelator = exports.getJobCorrelator = exports.complete = exports.setup = void 0;
const core = __importStar(require("@actions/core"));
const artifact = __importStar(require("@actions/artifact"));
const github = __importStar(require("@actions/github"));
const glob = __importStar(require("@actions/glob"));
const toolCache = __importStar(require("@actions/tool-cache"));
const rest_1 = require("@octokit/rest");
const path = __importStar(require("path"));
const fs_1 = __importDefault(require("fs"));
const layout = __importStar(require("./repository-layout"));
const input_params_1 = require("./input-params");
const DEPENDENCY_GRAPH_ARTIFACT = 'dependency-graph';
function setup(option) {
    if (option === input_params_1.DependencyGraphOption.Disabled || option === input_params_1.DependencyGraphOption.DownloadAndSubmit) {
        return;
    }
    core.info('Enabling dependency graph generation');
    const jobCorrelator = getJobCorrelator();
    core.exportVariable('GITHUB_DEPENDENCY_GRAPH_ENABLED', 'true');
    core.exportVariable('GITHUB_JOB_CORRELATOR', jobCorrelator);
    core.exportVariable('GITHUB_JOB_ID', github.context.runId);
    core.exportVariable('DEPENDENCY_GRAPH_REPORT_DIR', path.resolve(layout.workspaceDirectory(), 'dependency-graph-reports'));
}
exports.setup = setup;
function complete(option) {
    return __awaiter(this, void 0, void 0, function* () {
        switch (option) {
            case input_params_1.DependencyGraphOption.Disabled:
                return;
            case input_params_1.DependencyGraphOption.Generate:
                yield uploadDependencyGraphs();
                return;
            case input_params_1.DependencyGraphOption.GenerateAndSubmit:
                yield submitDependencyGraphs(yield uploadDependencyGraphs());
                return;
            case input_params_1.DependencyGraphOption.DownloadAndSubmit:
                yield downloadAndSubmitDependencyGraphs();
        }
    });
}
exports.complete = complete;
function uploadDependencyGraphs() {
    return __awaiter(this, void 0, void 0, function* () {
        const workspaceDirectory = layout.workspaceDirectory();
        const graphFiles = yield findDependencyGraphFiles(workspaceDirectory);
        const relativeGraphFiles = graphFiles.map(x => getRelativePathFromWorkspace(x));
        core.info(`Uploading dependency graph files: ${relativeGraphFiles}`);
        const artifactClient = artifact.create();
        artifactClient.uploadArtifact(DEPENDENCY_GRAPH_ARTIFACT, graphFiles, workspaceDirectory);
        return graphFiles;
    });
}
function downloadAndSubmitDependencyGraphs() {
    return __awaiter(this, void 0, void 0, function* () {
        const workspaceDirectory = layout.workspaceDirectory();
        submitDependencyGraphs(yield retrieveDependencyGraphs(workspaceDirectory));
    });
}
function submitDependencyGraphs(dependencyGraphFiles) {
    return __awaiter(this, void 0, void 0, function* () {
        const octokit = getOctokit();
        for (const jsonFile of dependencyGraphFiles) {
            const jsonContent = fs_1.default.readFileSync(jsonFile, 'utf8');
            const jsonObject = JSON.parse(jsonContent);
            jsonObject.owner = github.context.repo.owner;
            jsonObject.repo = github.context.repo.repo;
            const response = yield octokit.request('POST /repos/{owner}/{repo}/dependency-graph/snapshots', jsonObject);
            const relativeJsonFile = getRelativePathFromWorkspace(jsonFile);
            core.notice(`Submitted ${relativeJsonFile}: ${response.data.message}`);
        }
    });
}
function retrieveDependencyGraphs(workspaceDirectory) {
    return __awaiter(this, void 0, void 0, function* () {
        if (github.context.payload.workflow_run) {
            return yield retrieveDependencyGraphsForWorkflowRun(github.context.payload.workflow_run.id, workspaceDirectory);
        }
        return retrieveDependencyGraphsForCurrentWorkflow(workspaceDirectory);
    });
}
function retrieveDependencyGraphsForWorkflowRun(runId, workspaceDirectory) {
    return __awaiter(this, void 0, void 0, function* () {
        const octokit = getOctokit();
        const artifacts = yield octokit.rest.actions.listWorkflowRunArtifacts({
            owner: github.context.repo.owner,
            repo: github.context.repo.repo,
            run_id: runId
        });
        const matchArtifact = artifacts.data.artifacts.find(candidate => {
            return candidate.name === DEPENDENCY_GRAPH_ARTIFACT;
        });
        if (matchArtifact === undefined) {
            throw new Error(`Dependency graph artifact not found. Has it been generated by workflow run '${runId}'?`);
        }
        const download = yield octokit.rest.actions.downloadArtifact({
            owner: github.context.repo.owner,
            repo: github.context.repo.repo,
            artifact_id: matchArtifact.id,
            archive_format: 'zip'
        });
        const downloadBuffer = download.data;
        const downloadZip = path.resolve(workspaceDirectory, 'dependency-graph.zip');
        fs_1.default.writeFileSync(downloadZip, Buffer.from(downloadBuffer));
        const extractDir = path.resolve(workspaceDirectory, 'dependency-graph');
        const extracted = yield toolCache.extractZip(downloadZip, extractDir);
        core.info(`Extracted dependency graph artifacts to ${extracted}: ${fs_1.default.readdirSync(extracted)}`);
        return findDependencyGraphFiles(extracted);
    });
}
function retrieveDependencyGraphsForCurrentWorkflow(workspaceDirectory) {
    return __awaiter(this, void 0, void 0, function* () {
        const artifactClient = artifact.create();
        const downloadPath = path.resolve(workspaceDirectory, 'dependency-graph');
        yield artifactClient.downloadArtifact(DEPENDENCY_GRAPH_ARTIFACT, downloadPath);
        return yield findDependencyGraphFiles(downloadPath);
    });
}
function findDependencyGraphFiles(dir) {
    return __awaiter(this, void 0, void 0, function* () {
        const globber = yield glob.create(`${dir}/dependency-graph-reports/*.json`);
        const graphFiles = globber.glob();
        return graphFiles;
    });
}
function getOctokit() {
    return new rest_1.Octokit({
        auth: getGithubToken()
    });
}
function getGithubToken() {
    return core.getInput('github-token', { required: true });
}
function getRelativePathFromWorkspace(file) {
    const workspaceDirectory = layout.workspaceDirectory();
    return path.relative(workspaceDirectory, file);
}
function getJobCorrelator() {
    return constructJobCorrelator(github.context.workflow, github.context.job, (0, input_params_1.getJobMatrix)());
}
exports.getJobCorrelator = getJobCorrelator;
function constructJobCorrelator(workflow, jobId, matrixJson) {
    const matrixString = describeMatrix(matrixJson);
    const label = matrixString ? `${workflow}-${jobId}-${matrixString}` : `${workflow}-${jobId}`;
    return sanitize(label);
}
exports.constructJobCorrelator = constructJobCorrelator;
function describeMatrix(matrixJson) {
    core.debug(`Got matrix json: ${matrixJson}`);
    const matrix = JSON.parse(matrixJson);
    if (matrix) {
        return Object.values(matrix).join('-');
    }
    return '';
}
function sanitize(value) {
    return value
        .replace(/[^a-zA-Z0-9_-\s]/g, '')
        .replace(/\s+/g, '_')
        .toLowerCase();
}
